"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isILibraryCarouselCourseEntity = exports.isILibraryCarouselGroupEntity = void 0;
var isILibraryCarouselGroupEntity = function (item) {
    return item.__type === "plugin::strapi-plugin-shapeshift-cms.group";
};
exports.isILibraryCarouselGroupEntity = isILibraryCarouselGroupEntity;
var isILibraryCarouselCourseEntity = function (item) {
    return item.__type === "plugin::strapi-plugin-shapeshift-cms.course";
};
exports.isILibraryCarouselCourseEntity = isILibraryCarouselCourseEntity;
